module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/bankcreation/bankcreation.component.css
// module id = ./src/app/masters/bankcreation/bankcreation.component.css
// module chunks = main